const VIDEO = process.env.PUBLIC_URL + '/img/WhatsApp Video 2026-06-02 at 11.34.43 AM.mp4';

export default function BannerCTA() {
  return (
    <section className="banner-cta">
      <video
        className="banner-cta-bg"
        src={VIDEO}
        autoPlay
        muted
        loop
        playsInline
      />
      <div className="banner-cta-overlay" />
      <div className="banner-cta-content">
        <p className="section-overline" style={{ justifyContent: 'center' }}>DAET — Tepatitlán de Morelos</p>
        <h2 className="banner-cta-title">
          El mejor precio en acero,<br />
          <span>cerca de tu obra</span>
        </h2>
        <p className="banner-cta-sub">
          Materiales listos para llevar en Tepatitlán. Constructores, herreros
          y talleres — aquí encuentras lo que necesitas al precio más accesible.
        </p>
        <button
          className="btn btn-primary"
          onClick={() => document.getElementById('contacto')?.scrollIntoView({ behavior: 'smooth' })}
        >
          Solicitar cotización
        </button>
      </div>
    </section>
  );
}
